<template>
	<v-card class="elevation-0" >
		<v-row>
			<v-col cols="12" class="px-8">

				<v-expansion-panels multiple active-class>
					<v-expansion-panel
			      v-for="(item, i ) in hermanos"
			      :key="i"
			      class="elevation-10"
			    >
			      <v-expansion-panel-header>
			        Datos del hermano {{ i + 1 }}
			      </v-expansion-panel-header>
			      <v-expansion-panel-content>
					  	<!-- BUSCAR POR MATRICULA -->
					  	<b>Matricula:</b> {{ item.matricula }}
					  	<br/>
					  	<b>Nombre:</b> {{ item.nombre }} {{ item.apellido_paterno }} {{ item.apellido_materno }}

							<v-divider class="my-4"></v-divider>

							<!-- TIPO DE ALUMNOS -->
					  	<label >Estatus del alumno actualmente</label>
					  	<br/>
			        <span v-if="tipoAlumno == 1"><b>ALUMNO NI</b></span>
		          <span v-if="tipoAlumno == 2"><b>ALUMNO REGULAR</b></span>
		          <span v-if="tipoAlumno == 3" class="orange--text"><b>ALUMNO IRREGULAR</b></span>
		          <span v-if="tipoAlumno == 4" class="red--text"><b>ALUMNO CON ADEUDO</b></span>
		          <span v-if="tipoAlumno == 5" ><b>ALUMNO PENDIENTE DE ABRIR GRUPO</b></span>
		          <span v-if="tipoAlumno == 6" class="red--text"><b>ALUMNO CON DIFERENCIA DE PAGO</b></span>


							<v-divider class="my-4"></v-divider>

			        <v-card-title primary-title class="subtitle-1">
		            <b>Grupo Actual del alumno</b>
		          </v-card-title>
				  	  <v-card-text class="black--text">
						  	<div class="text-subtitle-1" v-if="item.getGrupoActual">
						  		{{ item.getGrupoActual.grupo }}
						  		<br/>
				          <strong class="red--text">Adeudo: $ {{ item.getGrupoActual.adeudo }}<br/></strong> 
						  	</div>
						  	<div class="text-subtitle-1" v-else>
						  		Sin grupo activo. Selecciona un grupo para este hermano.
						  	</div>
				  	  </v-card-text>


							<v-divider class="my-4"></v-divider>

							<!-- Hermano NI o sin grupo activo -->
			        <div v-if="esHermanoSinGrupo(item)">
			          <v-card-title primary-title class="subtitle-1">
			            Selecciona un grupo para el alumno
			          </v-card-title>
			          <v-card-text>
			            <v-tooltip bottom color="blue" max-width="300">
			              <template v-slot:activator="{ on, attrs }">
			                <v-autocomplete
			                  label="Grupos"
			                  dense
			                  v-model="item.grupoSiguiente"
			                  :items="grupos"
			                  item-text="grupo"
			                  item-value="id_grupo"
			                  clearable
			                  filled
			                  return-object
			                  v-bind="attrs"
			                  v-on="on"
			                ></v-autocomplete>
			              </template>
			              <span>Selecciona el grupo para inscribir a este hermano</span>
			            </v-tooltip>
			          </v-card-text>
			        </div>

							<!-- Alumno irregular, selecciona un nuevo grupo -->
			        <div v-if="[3].includes(item.tipoAlumno)">
			          <v-card-title primary-title class="subtitle-1">
			            Selecciona un nuevo grupo para el alumno
			          </v-card-title>
			          <v-card-text>
			            <v-tooltip bottom color="blue" max-width="300">
			              <template v-slot:activator="{ on, attrs }">
			                <v-autocomplete
			                  label="Grupos"
			                  dense
			                  v-model="item.grupoSiguiente"
			                  :items="grupos"
			                  item-text="grupo"
			                  item-value="id_grupo"
			                  clearable
			                  filled
			                  return-object
			                  v-bind="attrs"
			                  v-on="on"
			                ></v-autocomplete>
			              </template>
			              <span>Selecciona el grupo para reinscribir a este hermano irregular</span>
			            </v-tooltip>
			          </v-card-text>
			        </div>

				      <!-- ALUMNO RI REGUALAR -->
				      <!-- Seleccionar otro grupo, alumnos NO HERMANOS -->
			        <div v-if="[2,4,5].includes(item.tipoAlumno) && !esHermanoSinGrupo(item)">
			          <v-card-title primary-title class="subtitle-1">
			            <b>{{ tieneAdeudoHermano(item) ? 'Grupo de Cambio:' : 'Grupo siguiente:' }}</b>
			          </v-card-title>
			          <v-card-text class="black--text">
			            <!-- Seleccionar otro grupo diferente al siguiente -->
			            <v-tooltip bottom color="blue" max-width="300" v-if="item.otroGrupo">
			              <template v-slot:activator="{ on, attrs }">
			                <v-autocomplete
			                  label="Selecciona un grupo"
			                  dense
			                  v-model="item.grupoSiguiente"
			                  :items="item.gruposOtros || grupos"
			                  item-text="grupo"
			                  item-value="id_grupo"
			                  clearable
			                  filled
			                  return-object
			                  v-bind="attrs"
			                  v-on="on"
			                  :no-data-text="mensajeSinGruposCambio(item)"
			                ></v-autocomplete>
			              </template>
			              <span v-if="tieneAdeudoHermano(item)">Selecciona un grupo del ciclo de cambios (CAMBIOS)</span>
			              <span v-else>Elige manualmente el grupo para este hermano</span>
			            </v-tooltip>

			            <v-alert
			              v-if="tieneAdeudoHermano(item) && item.otroGrupo && !cargar && !(item.gruposOtros || grupos).length"
			              dense
			              outlined
			              type="warning"
			              class="mt-3"
			            >
			              No hay grupos del ciclo de cambios disponibles para este periodo.
			              Solicita a administración que abra un grupo de cambio (CAMBIOS).
			            </v-alert>

			            <div class="text-subtitle-1" v-if="tieneAdeudoHermano(item) ? item.getGrupoActual : item.grupoSiguiente">
			              <span v-if="!item.otroGrupo">{{ textoGrupoCambioHermano(item) }}</span>
			              <span v-if="item.capacidad">El siguiente grupo no cuenta con capacidad para inscribir alumnos</span>
			              <v-tooltip bottom color="blue" max-width="300">
			                <template v-slot:activator="{ on, attrs }">
			                  <v-switch
			                    :label="tieneAdeudoHermano(item) ? 'Activar grupos de Cambio' : 'Seleccionar otro grupo'"
			                    v-model="item.otroGrupo"
			                    hide-details
			                    v-bind="attrs"
			                    v-on="on"
			                    @change="onOtroGrupoHermano(item, $event)"
			                  ></v-switch>
			                </template>
			                <span v-if="tieneAdeudoHermano(item)">Solo se muestran grupos del ciclo de cambios (CAMBIOS)</span>
			                <span v-else>Activa para elegir un grupo diferente al sugerido</span>
			              </v-tooltip>
			            </div>

			            <div class="text-subtitle-1" v-if="!item.grupoSiguiente">
			              <strong>{{ errorMensaje }}
			                <br/>
			              </strong>
			              <span v-if="!item.otroGrupo"></span>
			              <v-tooltip bottom color="blue" max-width="300">
			                <template v-slot:activator="{ on, attrs }">
			                  <v-switch
			                    :label="tieneAdeudoHermano(item) ? 'Activar grupos de Cambio' : 'Seleccionar otro grupo'"
			                    v-model="item.otroGrupo"
			                    hide-details
			                    v-bind="attrs"
			                    v-on="on"
			                    @change="onOtroGrupoHermano(item, $event)"
			                  ></v-switch>
			                </template>
			                <span v-if="tieneAdeudoHermano(item)">Activa para ver los grupos del ciclo de cambios (CAMBIOS)</span>
			                <span v-else>Activa para seleccionar un grupo manualmente</span>
			              </v-tooltip>
			            </div>
			          </v-card-text>
			        </div>


			      </v-expansion-panel-content>
			    </v-expansion-panel>
			  </v-expansion-panels>
			</v-col>


		</v-row>

		<v-divider class="my-4"></v-divider>

		<v-card-actions>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            text 
            @click="dialogAddAlumno.estatus = false"
            v-bind="attrs"
            v-on="on"
          >
            Cancelar
          </v-btn>
        </template>
        <span>Cerrar y cancelar el proceso de reinscripción</span>
      </v-tooltip>
      
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn 
            tile
            color="primary"
            class="ml-2"
            @click="steppers.paso = 1"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left small>mdi-arrow-left</v-icon>
            Regresar
          </v-btn>
        </template>
        <span>Volver al paso anterior</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom color="blue" max-width="300">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
          	tile
            color="primary"
            @click="steppers.paso = 3"
            v-bind="attrs"
            v-on="on"
          >
            Siguiente
          	<v-icon right small>mdi-arrow-right</v-icon>
          </v-btn>
        </template>
        <span>Continuar al paso de realizar pago</span>
      </v-tooltip>
  	</v-card-actions>


  	<!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

    <AgregarProspecto     v-if="existeProspecto"             :parametrosProspectos="parametrosProspectos" @saveProspecto="saveProspecto"/>


	</v-card>
</template>
<script>

	import axios from 'axios';
	import { mapGetters, mapActions } from 'vuex'
  import Alerta          from '@/components/alertas/Alerta.vue'
  import carga           from '@/components/alertas/carga.vue';

  import AgregarProspecto   from '@/components/inscripciones/AgregarProspecto.vue';


  import validarErrores  from '@/mixins/validarErrores'

	// Componentes
  export default {
  	components:{
      Alerta,
      carga,
      AgregarProspecto
    },

    mixins: [ validarErrores ],

  	props:[
			'alumno',
			'steppers',
			'hermanos',
			'tutor'
	  ],

    data: () => ({
    	escuela: 2,
			// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      cargar: false,

    	prospectos:[],
    	parametrosProspectos:{
    		estatus: false
    	},

    	existeProspecto:false,
    	prospecto: null,
    	grupos:[],

    	grupo: null,
    	errorMensaje:null,
      otroGrupo: false,
      nuevoGrupoSeleccionado:null,
      tipoAlumno: null,
      cicloActual: null

    }),

    computed: {
    	...mapGetters('login',['getdatosUsuarioERPERP', 'getEscuela']),
    },

    watch:{

    },

    async created () {
    	this.escuela = this.getEscuela
    	await this.iniciarValidaciones( )
    },

    methods: {

    	async iniciarValidaciones( ){
        this.cargar = true
        let hermanos = await this.validarHermano( ).then( response => response )

        if( hermanos && hermanos.hermanos && hermanos.hermanos.length ){ 

        	console.log( 'hermanos',hermanos )
          // this.hermanos    = hermanos.hermanos
          this.tipoAlumno  = hermanos.tipoAlumno
          this.cicloActual = await this.obtenerCicloActualInscripciones()

          for( const i in hermanos.hermanos){
            if( typeof(hermanos.hermanos[i]) == 'object' && !hermanos.hermanos[i].tipoAlumno ){
              hermanos.hermanos[i]['tipoAlumno'] = this.tipoAlumno
            }
          }

          for( const i in this.hermanos ){

          	const { id_alumno } = this.hermanos[i]

          	console.log( id_alumno )

          	if( id_alumno ){
	          	const existeHermano = hermanos.hermanos.find( el => el.id_alumno == id_alumno )

	          	this.hermanos[i]['getGrupoActual'] = existeHermano ? existeHermano.getGrupoActual : null
	          	this.hermanos[i]['grupoSiguiente'] = existeHermano ? existeHermano.grupoSiguiente : null
	          	this.hermanos[i]['tipoAlumno']     = existeHermano ? existeHermano.tipoAlumno     : null
	          	this.hermanos[i]['otroGrupo']      = false
	          	this.hermanos[i]['gruposOtros']    = null
          	}

 
          }

          await this.getGruposDisponibles()
          
          this.cargar = false
          
          return
        }

        this.cargar = false
      },

      validarHermano( ){
        return new Promise(( resolve, reject ) => {
          const payload = {
            id_alumno: this.hermanos[0].id_alumno,
            escuela  : this.hermanos[0].unidad_negocio
          }

          this.$http.post('validar.hermanos', payload).then(response=>{
            resolve( response.data )
          }).catch( error =>{
            this.validarError( error.response && error.response.data && error.response.data.message )
            resolve( null )
          }).finally( () => { this.cargar = false })
        })
      },

      esHermanoSinGrupo ( item ) {
        const tipo = Number( item && item.tipoAlumno )
        if ( tipo === 1 ) return true
        return !item || !item.getGrupoActual
      },

      tieneAdeudoHermano ( item ) {
        if ( Number( item.tipoAlumno ) === 4 ) return true
        const actual = item && item.getGrupoActual
        return actual && Number( actual.adeudo ) > 0
      },

      mensajeSinGruposCambio ( item ) {
        if ( this.tieneAdeudoHermano( item ) ) {
          return 'Solicita a administración abrir un grupo de cambio (CAMBIOS)'
        }
        return 'No hay datos disponibles'
      },

      textoGrupoCambioHermano ( item ) {
        if ( this.tieneAdeudoHermano( item ) && item.getGrupoActual ) {
          return item.getGrupoActual.grupo
        }
        return item.grupoSiguiente ? item.grupoSiguiente.grupo : ''
      },

      obtenerCicloActualInscripciones () {
        const alumnoRef = this.hermanos && this.hermanos[0]
        if ( !alumnoRef || !alumnoRef.id_alumno ) return null

        const payload = {
          id_alumno: alumnoRef.id_alumno,
          escuela: alumnoRef.unidad_negocio || this.getEscuela
        }

        return this.$http.post( 'inscripciones.grupo.alumno', payload ).then( response => {
          return response.data.cicloActual || null
        }).catch( () => null )
      },

      getPeriodoCiclo ( grupoTexto ) {
        const match = ( grupoTexto || '' ).match( /(\d{2}_\d{2})/ )
        return match ? match[1] : null
      },

      periodoCambioAdeudo ( cicloActivo, grupoActual ) {
        if ( cicloActivo && cicloActivo.ciclo ) {
          const periodoActivo = this.getPeriodoCiclo( cicloActivo.ciclo )
          if ( periodoActivo ) return periodoActivo
        }
        if ( grupoActual ) {
          const periodoActual = this.getPeriodoCiclo( grupoActual.ciclo ) || this.getPeriodoCiclo( grupoActual.grupo )
          if ( periodoActual ) return periodoActual
        }
        return null
      },

      filtrarGruposCambio ( lista, periodo ) {
        if ( !lista || !lista.length ) return []
        return lista.filter( el => {
          const ciclo = ( el.ciclo || '' ).toUpperCase()
          const grupo = ( el.grupo || '' ).toUpperCase()
          const esCambios = ciclo.indexOf( 'CAMBIOS' ) >= 0 || grupo.indexOf( 'CAMBIOS' ) >= 0
          if ( !esCambios ) return false
          if ( periodo ) {
            return ciclo.indexOf( periodo ) >= 0 || grupo.indexOf( periodo ) >= 0
          }
          return true
        })
      },

      marcarTipoAlumnoEnGrupos ( grupos, tipoAlumno ) {
        for ( const i in grupos ) {
          grupos[i]['tipoAlumno'] = tipoAlumno
        }
      },

      onOtroGrupoHermano ( item, activo ) {
        if ( !activo ) {
          item.gruposOtros = null
          return
        }
        if ( this.tieneAdeudoHermano( item ) ) {
          this.getGruposCambioHermano( item )
        } else {
          this.ensureGruposDisponibles().then(() => {
            item.gruposOtros = this.grupos
          })
        }
      },

      ensureGruposDisponibles () {
        if ( this.grupos && this.grupos.length ) {
          return Promise.resolve()
        }
        return this.getGruposDisponibles()
      },

      getGruposDisponibles( ) {
        this.cargar = true

        return this.$http.get('grupos.disponibles/' + this.getEscuela ).then(response=>{
          this.grupos = response.data
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      getGruposCambioHermano ( item ) {
        const actual = item.getGrupoActual
        if ( !actual ) return

        this.cargar = true
        item.gruposOtros = []

        const periodo = this.periodoCambioAdeudo( this.cicloActual, actual )
        const escuela = item.unidad_negocio || this.getEscuela

        return this.$http.get('grupos.disponibles/' + escuela ).then(response=>{
          const filtrados = this.filtrarGruposCambio( response.data, periodo )
          this.marcarTipoAlumnoEnGrupos( filtrados, item.tipoAlumno )
          item.gruposOtros = filtrados
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

    },
  }
</script>
